import { render, staticRenderFns } from "./DefaultSelect.vue?vue&type=template&id=5b556594&scoped=true&"
import script from "./DefaultSelect.vue?vue&type=script&lang=ts&"
export * from "./DefaultSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b556594",
  null
  
)

export default component.exports